import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

export const PARTNER_DATE_RANGE_LABEL = '';

export const PARTNER_PROFILE = {
  name: '',
  description: '',
};

export const PARTNER_STATS = [
  {
    id: 'active-members',
    title: 'Active Members',
    value: '',
    trend: null,
    trendUp: true,
    subtitle: 'Engaged in last 30 days',
    icon: GroupsOutlinedIcon,
    iconBg: '#E8F4FD',
    iconColor: '#1E88E5',
  },
  {
    id: 'repeat-attendance',
    title: 'Repeat Attendance',
    value: '',
    trend: null,
    trendUp: true,
    subtitle: 'Attendees returning to events',
    icon: SyncOutlinedIcon,
    iconBg: '#FFF0E6',
    iconColor: '#E0680A',
  },
  {
    id: 'connection-quality',
    title: 'Connection Quality',
    value: '',
    trend: null,
    trendUp: true,
    subtitle: 'Based on post-event feedback',
    icon: FavoriteBorderOutlinedIcon,
    iconBg: '#FCE8F0',
    iconColor: '#E91E8C',
  },
  {
    id: 'upcoming-events-count',
    title: 'Upcoming Events',
    value: '',
    trend: null,
    trendUp: false,
    subtitle: 'Scheduled for this month',
    icon: CalendarMonthOutlinedIcon,
    iconBg: '#FFEBEE',
    iconColor: '#E53935',
  },
];

export const COMMUNITY_HEALTH = {
  repeatAttendance: '',
  avgRating: '',
  bars: [
    { label: 'Invites Sent', value: '', percent: 0, color: 'primary.main' },
    { label: 'RSVPs Received', value: '', percent: 0, color: '#4caf50' },
    { label: 'Attended', value: '', percent: 0, color: '#2196f3' },
    { label: 'Repeat Attendees', value: '', percent: 0, color: '#ffc107' },
  ],
};
